export interface TenantSocialLinks {
  whatsapp?: string;
  instagram?: string;
  facebook?: string;
  tiktok?: string;
  website?: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function cleanText(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function normalizeExternalUrl(value: string | undefined): string | undefined {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function normalizeWhatsappValue(value: string | undefined): string | undefined {
  if (!value) return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  const waUrlMatch = trimmed.match(/wa\.me\/(\d+)/i);
  if (waUrlMatch?.[1]) return waUrlMatch[1];

  const phoneParamMatch = trimmed.match(/[?&]phone=(\d+)/i);
  if (phoneParamMatch?.[1]) return phoneParamMatch[1];

  const digits = trimmed.replace(/\D/g, '');
  return digits.length >= 7 ? digits : undefined;
}

export function buildWhatsappUrl(value: string | undefined): string | undefined {
  const normalized = normalizeWhatsappValue(value);
  return normalized ? `https://wa.me/${normalized}` : undefined;
}

export function getTenantSocialLinks(settings: unknown): TenantSocialLinks {
  if (!isRecord(settings)) return {};
  const socialLinks = settings.social_links;
  if (!isRecord(socialLinks)) return {};

  return {
    whatsapp: cleanText(socialLinks.whatsapp),
    instagram: cleanText(socialLinks.instagram),
    facebook: cleanText(socialLinks.facebook),
    tiktok: cleanText(socialLinks.tiktok),
    website: cleanText(socialLinks.website),
  };
}

export function cleanTenantSocialLinks(links: TenantSocialLinks): TenantSocialLinks {
  const cleaned: TenantSocialLinks = {};

  const whatsapp = normalizeWhatsappValue(links.whatsapp);
  const instagram = normalizeExternalUrl(links.instagram);
  const facebook = normalizeExternalUrl(links.facebook);
  const tiktok = normalizeExternalUrl(links.tiktok);
  const website = normalizeExternalUrl(links.website);

  if (whatsapp) cleaned.whatsapp = whatsapp;
  if (instagram) cleaned.instagram = instagram;
  if (facebook) cleaned.facebook = facebook;
  if (tiktok) cleaned.tiktok = tiktok;
  if (website) cleaned.website = website;

  return cleaned;
}
